<template>
    <div class="animated fadeIn bgV2" :class="[{'run-loading': loadingCheckListDetail}]">
        <b-row>
            <b-col md="12">
                <h3 class="ml-4 mt-25 mb-25 font-30">{{item.name_checklist_templates}} <span class="desc-section"><img @click="openCheckList" class="cursor-pointer" height="16" src="img/iconPencil.png" alt=""></span></h3>
                <gofix-tab class="mt-3" :data="tabData">
                    <template slot="gofixTab:basic-info">
                        <b-row>
                            <b-col md="12" v-for="(section, index) in sections" :key="index">
                                <gofix-card :title="section.name" fullContent class="propertyInventoryCard" collapse>
                                    <template slot="gofixCard:after_title">
                                        <span @click.stop="openModalUpdateSection(section, false)" class="desc-section"><img class="cursor-pointer" height="16" src="img/iconPencil.png" alt=""></span>
                                    </template>
                                    <template slot="gofixCard:right_header">
                                        <div class="d-flex justify-content-end align-items-center">
                                            <span  @click="confirmDeleteSection(section)" class="search pull-right">
                                                <img class="cursor-pointer" width="14" height="14" src="img/close.png" alt="delete">
                                            </span>
                                        </div>
                                    </template>
                                    <template v-if="section.children.length > 0">
                                        <template v-for="(item_section, index_section) in section.children">
                                            <gofix-card :title="item_section.name" :key="index_section" fullContent class="propertyInventoryCard paddingSectionCustom" collapse>
                                                <template slot="gofixCard:after_title">
                                                    <span @click.stop="openModalUpdateSection(item_section, true)" class="desc-section"><img class="cursor-pointer" height="16" src="img/iconPencil.png" alt=""></span>
                                                </template>
                                                <template slot="gofixCard:right_header">
                                                    <div class="d-flex justify-content-end align-items-center">
                                                        <span @click="confirmDeleteSection(item_section)" class="search pull-right">
                                                            <img class="cursor-pointer" width="14" height="14" src="img/close.png" alt="delete">
                                                        </span>
                                                    </div>
                                                </template>
                                                <div class="gofixBasicTable" v-if="item_section.checklist_template_entries && item_section.checklist_template_entries.length > 0" >
                                                    <div class="dataList dataListSection">
                                                        <b-table fixed :responsive="true" class="animated fadeIn gofixTables border-1" :items="item_section.checklist_template_entries" :fields="fields">
                                                            <template slot="sequence" slot-scope="row">
                                                                {{ row.item.sequence}}
                                                            </template>
                                                            <template slot="name" slot-scope="row">
                                                                {{ row.item.name}}
                                                            </template>
                                                            <template slot="type" slot-scope="row">
                                                                {{ row.item.input.data_type}}
                                                            </template>
                                                            <template slot="value" slot-scope="row">
                                                                <div class="type-options">
                                                                    <div v-if="row.item.input.data_type === 'Reading'" class="d-flex">
                                                                        <div class="group">
                                                                            <span class="value">{{row.item.input.low_threshold}} {{row.item.input.high_threshold}} {{(row.item.input.unit)? `(${row.item.input.unit})`:''}} </span>
                                                                            <span v-if="row.item.input.calculated">
                                                                                {{ row.item.input.calculated | displayNameFunction }}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="row.item.input.data_type === 'Dropdown'" class="d-flex align-items-center">
                                                                            <span class="value">
                                                                                {{(row.item.input.possible_value) ? `(${row.item.input.possible_value.join(", ")})` : ''}}
                                                                            </span>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template slot="action" slot-scope="row">
                                                                <div class="text-right">
                                                                    <span class="mr-4"><img @click="openModalEditCheckListEntriesItem(row.item)" class="cursor-pointer" height="16" src="img/iconPencil.png" alt=""></span>
                                                                    <span><img class="cursor-pointer" @click="confirmDeleteEntries(row.item.id)" width="14" height="14" src="img/close.png" alt="delete"></span>
                                                                </div>
                                                            </template>
                                                        </b-table>
                                                    </div>
                                                </div>
                                                <div class="sub-section-checklist">
                                                    <div class="btnGroupPlus">
                                                        <gofix-button class="mb-0 gofixButtonFix" label="Add new checklist item +" @click="openModalAddItem(item_section)" outline></gofix-button>
                                                    </div>
                                                </div>
                                            </gofix-card>
                                        </template>
                                        <template>
                                            <div class="sub-section-checklist">
                                                <div class="btnGroupPlus mt-2">
                                                    <gofix-button class="gofixButtonFix" :disabled="section && section.children && section.children.length === 0" label="Add new sub section +" @click="openModalAddSection(section,true)" outline></gofix-button>
                                                    <gofix-button class="gofixButtonFix" :disabled="section && section.children && section.children.length > 0" label="Add new checklist item +" @click="openModalAddItem(section)" outline></gofix-button>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <div class="gofixBasicTable" v-if="section && section.checklist_template_entries.length > 0">
                                            <div class="dataList dataListSection paddingSectionCustom">
                                                <b-table fixed :responsive="true" class="animated fadeIn gofixTables" :items="section.checklist_template_entries" :fields="fields">
                                                    <template slot="sequence" slot-scope="row">
                                                        {{ row.item.sequence}}
                                                    </template>
                                                    <template slot="name" slot-scope="row">
                                                        {{ row.item.name}}
                                                    </template>
                                                    <template slot="type" slot-scope="row">
                                                        {{ row.item.input.data_type}}
                                                    </template>
                                                    <template slot="value" slot-scope="row">
                                                        <div class="type-options">
                                                            <div v-if="row.item.input.data_type === 'Reading'" class="d-flex">
                                                                <div class="group">
                                                                    <span class="value">{{row.item.input.low_threshold}} {{row.item.input.high_threshold}} {{(row.item.input.unit)? `(${row.item.input.unit})`:''}} </span>
                                                                    <span v-if="row.item.input.calculated">
                                                                        {{ row.item.input.calculated | displayNameFunction }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div v-if="row.item.input.data_type === 'Dropdown'" class="d-flex align-items-center">
                                                                <span class="value">
                                                                    {{(row.item.input.possible_value) ? `(${row.item.input.possible_value.join(", ")})` : ''}}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template slot="action" slot-scope="row">
                                                        <div class="text-right">
                                                            <span class="mr-4"><img @click="openModalEditCheckListEntriesItem(row.item)" class="cursor-pointer" height="16" src="img/iconPencil.png" alt=""></span>
                                                            <span><img class="cursor-pointer" @click="confirmDeleteEntries(row.item.id)" width="14" height="14" src="img/close.png" alt="delete"></span>
                                                        </div>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </div>
                                        <div class="sub-section-checklist">
                                            <div class="btnGroupPlus mt-2">
                                                <gofix-button class="gofixButtonFix" :disabled="section && section.checklist_template_entries && section.checklist_template_entries.length > 0" label="Add new sub section +" @click="openModalAddSection(section,true)" outline></gofix-button>
                                                <gofix-button class="gofixButtonFix" :disabled="section && section.children && section.children.length > 0" label="Add new checklist item +" @click="openModalAddItem(section)" outline></gofix-button>
                                            </div>
                                        </div>
                                    </template>
                                </gofix-card>
                            </b-col>
                            <b-col md="12">
                               <div class="btnGroupPlus">
                                    <gofix-button class="mt-2 gofixButtonFix" @click="openModalAddSection('',false)" label="Add new section +" outline></gofix-button>
                                </div>
                            </b-col>
                        </b-row>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-checklist-name" title="Checklist Name" hide-footer :centered="true" ref="modal-checklist-name" v-model="modals.checklist.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input required label="Checklist Name" v-model="modals.checklist.name"></gofix-form-input>
                        <gofix-form-input required label="Type" v-model="modals.checklist.type"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="updateCheckListTemplate" :disabled="$disabledCreateOrUpdate(this.item, $accessModule.checklist_template_master)" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!-- Update Section -->
        <b-modal :no-close-on-backdrop="true" id="modal-Create-Section" :title="modals.section.update.title" hide-footer :centered="true" ref="modal-Create-Section" v-model="modals.section.update.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input required :label="modals.section.update.title" v-model="modals.section.update.name"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" :loading="modals.section.update.loading" :disabled="$disabledCreateOrUpdate(this.item, $accessModule.checklist_template_master)" @click="updateSectionName" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!-- Create new Section -->
        <b-modal :no-close-on-backdrop="true" id="modal-Create-Section" :title="modals.section.create.title" hide-footer :centered="true" ref="modal-Create-Section" v-model="modals.section.create.open">
            <b-form class="pb-20">
                <b-row>
                    <b-col md="12">
                        <gofix-form-input required :label="modals.section.create.title" v-model="modals.section.create.name"></gofix-form-input>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" :loading="modals.section.create.loading" :disabled="$disabledCreateOrUpdate(this.item, $accessModule.checklist_template_master)" @click="createSectionName" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" v-model="modals.section.delete.open" title="Delete" hide-footer hide-header :centered="true" ref="modal-Remove">
            <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="$bvModal.hide('modal-Remove')">No</b-button>
                <b-button class="custom-btn" @click="deleteSection" :loading="modals.section.delete.loading" :disabled="$disabledCreateOrUpdate(this.item, $accessModule.checklist_template_master)">Yes</b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" v-model="modals.entries.delete.open" title="Delete" hide-footer hide-header :centered="true" ref="modal-Remove">
            <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="$bvModal.hide('modal-Remove')">No</b-button>
                <b-button class="custom-btn" @click="deleteCheckListTemplateEntries" :loading="modals.entries.delete.loading" :disabled="$disabledCreateOrUpdate(this.item, $accessModule.checklist_template_master)">Yes</b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Item Detail" hide-footer :centered="true" ref="modal-Create" v-model="modals.entries.open">
            <b-form class="pb-20" v-if="modals.entries.data">
                <gofix-form-input label="Number" v-model="modals.entries.data.sequence" required></gofix-form-input>
                <gofix-form-input label="Service Description" v-model="modals.entries.data.name" required></gofix-form-input>
                <gofix-form-dropdown
                        label="Value Type"
                        :clearable="false"
                        v-model="modals.entries.data.input.data_type"
                        :options="modals.entries.list">
                </gofix-form-dropdown>
                <b-row v-show="modals.entries.data.input.data_type === 'Reading'">
                    <b-col md="12">
                        <gofix-form-input label="Unit" v-model="modals.entries.data.input.unit"></gofix-form-input>
                    </b-col>
                    <b-col>
                        <gofix-form-input-number label="Min" v-model="modals.entries.data.input.low_threshold" :includeThousandsSeparator="false" allowNegative required></gofix-form-input-number>
                    </b-col>
                    <b-col>
                        <gofix-form-input-number label="Max" v-model="modals.entries.data.input.high_threshold" :includeThousandsSeparator="false" allowNegative required></gofix-form-input-number>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-dropdown
                            vLabel="label"
                            label="Based On Calculation"
                            :clearable="true"
                            :reduce="option => option.value"
                            v-model="modals.entries.data.formula_code"
                            :options="calculateFunction">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <div v-show="modals.entries.data.input.data_type === 'Dropdown'">
                    <gofix-form-input
                            v-for="(textService,index) in modals.entries.data.input.possible_value" :key="index"
                            label="Value Item"
                            v-model="modals.entries.data.input.possible_value[index]">
                        <template #gofixInput:text:after-desc>
                            <button type="button" class="btn btnDeleteService btn-secondary" @click="modals.entries.data.input.possible_value.splice(index, 1)"><img class="cursor-pointer" src="img/close.png" alt="close"></button>
                        </template>
                    </gofix-form-input>
                    <div class="text-center"><gofix-button label="ADD NEW SERVICE +" @click="modals.entries.data.input.possible_value.push('')" outline></gofix-button></div>
                </div>
                <!-- <b-form-checkbox v-if="isShowPhotoRequirement" v-model="modals.entries.data.photo_requirement" class="checkbox-main-allow mt-0">
                    <span class="ml-2">Photo requirements</span>
                </b-form-checkbox> -->
            </b-form>

            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" :disabled="$disabledCreateOrUpdate(this.item, $accessModule.checklist_template_master)" :loading="modals.entries.loading" @click="saveCheckListEntriesItem" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>


<script>
    import { mapGetters } from 'vuex';
    export default {
        name: 'checklist-template-info',
        computed: {
            ...mapGetters({
                template: 'v2CheckListTemplateController/templateItem',
            })
        },
        data () {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                ],
                loadingCheckListDetail:false,
                item:{
                    id : null,
                    content_checklist_templates: null,
                    name_checklist_templates: 'CheckList Name',
                    contract_id: this.$route.params.id ? this.$route.params.id : 0  ,
                    is_master: this.$route.params.id ? true : false,
                    group_root_id:null
                },
                sections:[],
                fields: [
                    {
                        key: 'sequence',
                        label: 'Number',
                        thStyle: "width: 135px"
                    },
                    {
                        key: 'name',
                        label: 'Service Description',
                        thStyle: "width: 350px"
                    },
                    {
                        key: 'type',
                        label: 'Value Type',
                        thStyle: "width: 200px"
                    },
                    {
                        key: 'value',
                        label: 'Value'
                    },
                    {
                        key: 'action',
                        label: '',
                        thStyle: "width: 200px"
                    }
                ],
                calculateFunction:[{label:'Calculated One',value:'calculated_one'}],
                keyReports: [],
                keyFilters: {},
                modals : {
                    checklist:{
                        id:null,
                        open : false,
                        name : null,
                        type: null
                    },
                    section : {
                        update:{
                            id:null,
                            name:null,
                            open:false,
                            title:"Section Name",
                            loading:false,
                        },
                        create:{
                            name:null,
                            open:false,
                            title:"Section Name",
                            loading:false,
                            parent_id:null,
                        },
                        delete:{
                            open:false,
                            loading:false,
                            data:null
                        },
                        section:{
                            title:"Section Name",
                            label:"Section Name"
                        },
                        sub_section:{
                            title:"Sub Section Name",
                            label:"Sub Section Name"
                        },
                        config:{

                            title:null,
                            label:null,
                        }
                    },
                    entries:{
                        list:["Checkbox","Reading","Free text","Dropdown"],
                        data:null,
                        loading:false,
                        open:false,
                        delete:{
                            open:false,
                            loading:false,
                            id:null
                        }
                    }
                }
            }
        },
        computed: {
            isShowPhotoRequirement: function() {
                return this.item && ['PTW Lifting Operations', 'PTW Hot Works', 'PTW WAH'].includes(this.item.type) ? true : false;
            }
        },
        async created() {
            if(this.$route.params.checklist_template_id && this.$route.params.id){
                 this.reloadCheckListEntries();
            }
            //this.getListKeyReport();
        },
        filters: {
            displayNameFunction: function(val) {
                let functions = {
                    calculated_one: "Calculated One"
                }
                if(functions[val]) return `- ${functions[val]}`;
            }
        },
        methods:{
            async reloadCheckListEntries(){
                this.loadingCheckListDetail = true;
                let checklist_id = parseInt(this.$route.params.checklist_template_id)
                if(checklist_id){
                    await this.$store.dispatch( 'v2CheckListTemplateController/getItemTemplate', checklist_id)
                        .then(response => {
                            this.item = response.data.data;
                        })
                        .catch(error => {
                            return this.$router.push(this.$route.matched[this.$route.matched.length - 1].parent.path)
                        })
                    if(this.item.id){
                        await this.$store.dispatch( 'v2CheckListTemplateController/getCheckListTemplateEntries', this.item.group_root_id)
                            .then(response => {
                                this.sections = response.data.data.items;
                                this.loadingCheckListDetail = false;
                            })
                            .catch(error => {
                                this.loadingCheckListDetail = false
                            })
                    }else{
                        this.loadingCheckListDetail = false;
                    }
                }else{
                    if(this.template && this.template.hasOwnProperty('id') && this.template.name_checklist_templates){
                        this.item = this.template
                    }
                    this.loadingCheckListDetail = false
                }
            },
            updateSectionName(){
                this.modals.section.update.loading = true;
                let request = {
                    id: this.modals.section.update.id,
                    name: this.modals.section.update.name
                };
                this.$store.dispatch( 'v2CheckListTemplateController/updateChecklistTemplateGroup', request)
                    .then(response => {
                        this.modals.section.update.loading = false;
                        this.modals.section.update.open = false;
                        this.reloadCheckListEntries();
                        return this.$alertNotification('Update section name successfully!','success');
                    })
                    .catch(error => {
                        this.modals.section.update.loading = false;
                        this.modals.section.update.open = false;
                        if(err.response) this.$alertNotification('Error. Please try again!','danger');
                    })
            },
            openModalUpdateSection(section, is_sub_section){
                this.modals.section.update.open = true
                this.modals.section.update.title = 'Section Name'
                this.modals.section.update.name = section.name;
                this.modals.section.update.id = section.id;
                if(is_sub_section){
                    this.modals.section.update.title = 'Sub Section Name';
                }
            },
            openModalAddSection(section, is_sub_section){
                this.modals.section.create.open = true
                this.modals.section.create.title = 'Section Name'
                this.modals.section.create.parent_id = this.item && this.item.group_root_id;
                this.modals.section.create.name = '';
                if(is_sub_section){
                    this.modals.section.create.parent_id = section && section.id;
                    this.modals.section.create.title = 'Sub Section Name';
                }
            },
            createSectionName(){
                this.modals.section.create.loading = true;
                let request = {
                    name: this.modals.section.create.name,
                    parent_id: this.modals.section.create.parent_id
                };
                this.$store.dispatch( 'v2CheckListTemplateController/createChecklistTemplateGroup', request)
                    .then(response => {
                        this.modals.section.create.loading = false;
                        this.modals.section.create.open = false;
                        this.reloadCheckListEntries();
                        return this.$alertNotification('Create new section successfully!','success');
                    })
                    .catch(error => {
                        this.modals.section.create.loading = false;
                        this.modals.section.create.open = false;
                        if(err.response) this.$alertNotification('Error. Please try again!','danger');
                    })
            },
            confirmDeleteSection(section){
                this.modals.section.delete.open = true;
                this.modals.section.delete.data = section
            },
            deleteSection() {
                this.modals.section.delete.loading = true;
                let request = {
                    id: this.modals.section.delete.data && this.modals.section.delete.data.id
                };
                this.$store.dispatch( 'v2CheckListTemplateController/deleteChecklistTemplateGroup', request)
                    .then(response => {
                        this.modals.section.delete.loading = false;
                        this.modals.section.delete.open = false;
                        this.reloadCheckListEntries();
                        return this.$alertNotification('Deleted successfully!','success');
                    })
                    .catch(error => {
                        this.modals.section.delete.loading = false;
                        this.modals.section.delete.open = false;
                        return this.$alertNotification('Error. Please try again!','danger');
                    })
            },
            openModalEditCheckListEntriesItem(data){
                let params = JSON.parse(JSON.stringify(data));
                if(this.isShowPhotoRequirement) {
                    params.photo_requirement = data.expand && data.expand.photo_requirement ? true : false;
                }
                this.modals.entries.data = params;
                this.modals.entries.open = true;
            },
            openModalAddItem(section){
                this.modals.entries.data = {
                    id:null,
                    sequence: '',
                    name: '',
                    preset_actions: null,
                    checklist_template_id: this.item && this.item.id,
                    template_section_id: section && section.id,
                    formula_code:null,
                    input:{
                        data_type: "Checkbox",
                        possible_value:[],
                        low_threshold: null,
                        high_threshold: null,
                        unit: null,
                        value: null,
                    }
                };
                this.modals.entries.open = true
            },
            openCheckList(){
                this.modals.checklist.id = this.item.id
                this.modals.checklist.name = this.item.name_checklist_templates
                this.modals.checklist.type = this.item.type
                this.modals.checklist.open = true
            },
            updateCheckListTemplate(){
                if(!this.modals.checklist.name){
                    return this.$alertNotification("Please enter to required fields", "danger");
                }
                let request = {
                    id: this.modals.checklist.id,
                    name_checklist_templates: this.modals.checklist.name,
                    type: this.modals.checklist.type
                };
                this.$store.dispatch( `v2CheckListTemplateController/updateTemplate`, request)
                    .then(response => {
                        this.item.name_checklist_templates = this.modals.checklist.name
                        this.item.type = this.modals.checklist.type
                        this.modals.checklist.name = null
                        this.modals.checklist.open = false
                        return this.$alertNotification(this.$notificationV2('editing', 'checklist_template'));
                    })
                    .catch(err => {
                        this.modals.checklist.open = false
                        if(err.response) this.$alertNotification('Can\'t update checklist template!', "danger");
                })
            },
            saveCheckListEntriesItem(){
                if(!this.modals.entries.data.sequence || !this.modals.entries.data.name){
                    return this.$alertNotification("Please enter to required fields", "danger");
                }

                if(this.modals.entries.data && this.modals.entries.data.input && this.modals.entries.data.input.data_type === 'Reading'){
                    if((this.modals.entries.data.input.low_threshold === null || this.modals.entries.data.input.low_threshold === undefined || this.modals.entries.data.input.low_threshold === '') || (this.modals.entries.data.input.high_threshold === null || this.modals.entries.data.input.high_threshold === undefined || this.modals.entries.data.input.high_threshold === '')){
                        return this.$alertNotification("Please enter to required fields", "danger");
                    }
                    this.modals.entries.data.input.low_threshold = parseFloat(this.modals.entries.data.input.low_threshold);
                    this.modals.entries.data.input.high_threshold = parseFloat(this.modals.entries.data.input.high_threshold);
                }
                if(this.modals.entries.data && this.modals.entries.data.input.data_type === 'Dropdown'){
                    if(this.modals.entries.data.input.possible_value.length < 1){
                        return this.$alertNotification("Please enter at least one value for the dropdown", "danger");
                    }
                }
                this.modals.entries.loading = true;
                const params = {
                    ...this.modals.entries.data
                }
                if(this.isShowPhotoRequirement) {
                    params.expand = this.modals.entries.data.photo_requirement ? {
                        photo_requirement: true
                    } : null
                    delete params.photo_requirement
                }
                if(this.modals.entries.data.id){
                    this.$store.dispatch( `v2CheckListTemplateController/updateChecklistTemplateEntries`, params)
                    .then(response => {
                        this.modals.entries.open = false
                        this.modals.entries.loading = false;
                        this.reloadCheckListEntries();
                        return this.$alertNotification('Updated checklist entries template successfully!','success');
                    })
                    .catch(err => {
                        console.log(err)
                        this.modals.entries.loading = false;
                        if(err.response) this.$alertNotification('Can\'t update checklist template entries!', "danger");
                    })
                    return;
                }
                //Create
                this.$store.dispatch( `v2CheckListTemplateController/createChecklistTemplateEntries`, params)
                    .then(response => {
                        this.modals.entries.open = false
                        this.modals.entries.loading = false;
                        this.reloadCheckListEntries();
                        return this.$alertNotification('Created checklist entries template successfully!','success');
                    })
                    .catch(err => {
                        this.modals.entries.open = false
                        this.modals.entries.loading = false;
                        if(err.response) this.$alertNotification('Can\'t create checklist template entries!', "danger");
                    })
                return;
            },
            confirmDeleteEntries(id){
                this.modals.entries.delete.open = true;
                this.modals.entries.delete.id = id;
            },
            deleteCheckListTemplateEntries(){
                this.$store.dispatch( `v2CheckListTemplateController/deleteChecklistTemplateEntries`, [this.modals.entries.delete.id])
                .then(response => {
                    this.modals.entries.delete.open = false
                    this.modals.entries.delete.id = null
                    this.reloadCheckListEntries();
                    return this.$alertNotification('Deleted checklist template entries successfully!','success');
                })
                .catch(err => {
                    this.modals.entries.open = false
                    this.modals.entries.loading = false;
                    return this.$alertNotification('Can\'t delete checklist template entries!', "danger");
                })
                
            },
            getListKeyReport() {
                this.$store.dispatch("MappingReportController/getItems", {
                    filter: { type: "5Y" }
                })
                .then(response => {
                    this.keyReports = response.data;
                    this.keyFilters = response.keys;
                })
                .catch(err => {
                    console.log(err);
                });
            }
        }
    }
</script>